import React, { useState, useEffect } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { GetUserVideo, getVideo } from './../../s3Func/s3Download';
import { API } from 'aws-amplify';
import { CloudfrontVideoFormat } from '../../videos/CloudfrontVideoFormat';
import './Practice.css';
import Day4Practice from '../../Unit2/Day4Practice/Day4Practice';

/**
 *  Creates and runs the practice section for Unit3 Module4
 *  Note: This code is reused in other modules as well
 * @param {*} props
 * @returns the HTML code for the practice section.
 */
const SolutionsPractice = (props) => {
  // Generate a random number based on the arraysize passed in
  function getRandomInt(arraysize) {
    return Math.floor(Math.random() * Math.floor(arraysize));
  }

  // Initialize variables to be used later
  const dispatch = useDispatch();
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [practiceVideo, setPracticeVideo] = useState(false);
  const [practice, setPractice] = useState(false);
  let [practiceCount, setPracticeCount] = useState(0);
  const [displayPracticeVideo, setDisplayPracticeVideo] = useState('');
  const [question, setQuestion] = useState(false);
  const [matchGame, setMatchGame] = useState(false);
  const [introSound, setIntroSound] = useState('');
  const [animalVoice, setAnimalVoice] = useState('');
  const [animalTalk, setAnimaTalk] = useState(false);
  const [score, setScore] = useState(0);
  const [firstTime, setFirstTime] = useState(true);
  const [selectImage, setSelectImage] = useState(null);
  const [changeAnswer, setChangeAnswer] = useState(false);
  const [option1, setOption1] = useState('');
  const [option2, setOption2] = useState('');
  const [answerkey, setAnswerkey] = useState(null);
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const Exit = generateImageUrl('images/Images/close.png');
  const greenCheck = generateImageUrl('images/Module1Images/GreenCheck-Button.png');
  const Mad_Calm = generateImageUrl('images/Module12Images/Practice_Puzzel_Mad_Calm@2x.png');
  const Nervous_Confident = generateImageUrl('images/Module12Images/Practice_Puzzel_Nervous_Confident@2x.png');
  const Sad_happy = generateImageUrl('images/Module12Images/Practice_Puzzel_Sad_happy@2x.png');

  const [keyword, setKeyword] = useState('');
  const [practiceReview, setPracticeReview] = useState(false);
  const [practiceRrcording, setPracticeRrcording] = useState(false);

  // Initializes answer possibilities (Get mad, scream, frown, ect.)
  const solutionGetMad = {
      img: generateImageUrl('images/Module14Images/practice/I will get mad.png'),
      title: 'I will get mad',
      audio: 'appfiles/solutions/solution_mad.mp3',
      positive: false,
  };
  const solutionScream = {
      img: generateImageUrl('images/Module14Images/practice/I will scream.png'),
      title: 'I will scream',
      audio: 'appfiles/solutions/solution_scream.mp3',
      positive: false,
  };
  const solutionFrown = {
      img: generateImageUrl('images/Module14Images/practice/I will frown.png'),
      title: 'I will frown',
      audio: 'appfiles/solutions/solution_frown.mp3',
      positive: false,
  };
  const solutionBreakGame = {
      img: generateImageUrl('images/Module14Images/practice/I will break my game.png'),
      title: 'I will break my game',
      audio: 'appfiles/solutions/solution_break_game.mp3',
      positive: false,
  };
  const solutionDeepBreath = {
      img: generateImageUrl('images/Module14Images/practice/I will take deep breaths.png'),
      title: 'I will take deep breaths',
      audio: 'appfiles/solutions/solution_deep_breath.mp3',
      positive: true,
  };
  const solutionEatFood = {
      img: generateImageUrl('images/Module14Images/practice/I will eat some food.png'),
      title: 'I will eat some food',
      audio: 'appfiles/solutions/solution_eat_food.mp3',
      positive: true,
  };
  const solutionCalm = {
      img: generateImageUrl('images/Module14Images/practice/I will be calm.png'),
      title: 'I will be calm',
      audio: 'appfiles/solutions/solution_calm.mp3',
      positive: true,
  };
  const solutionChores = {
      img: generateImageUrl('images/Module14Images/practice/I will do my chores.png'),
      title: 'I will do my chores',
      audio: 'appfiles/solutions/solution_chores.mp3',
      positive: true,
  };
  const solutionSnack = {
      img: generateImageUrl('images/Module14Images/practice/I will have a snack.png'),
      title: 'I will have a snack',
      audio: 'appfiles/solutions/solution_snack.mp3',
      positive: true,
  };
  const solutionBandaid = {
      img: generateImageUrl('images/Module14Images/practice/I will use a bandaid.png'),
      title: 'I will use a band-aid',
      audio: 'appfiles/solutions/solution_bandaid.mp3',
      positive: true,
  };
  const solutionSmile = {
      img: generateImageUrl('images/Module14Images/practice/I will smile.png'),
      title: 'I will smile',
      audio: 'appfiles/solutions/solution_smile.mp3',
      positive: true,
  };
  const solutionTall = {
      img: generateImageUrl('images/Module14Images/practice/I will stand tall.png'),
      title: 'I will stand tall',
      audio: 'appfiles/solutions/solution_tall.mp3',
      positive: true,
  };
  const solutionAnimal = {
      img: generateImageUrl('images/Module14Images/practice/I will get my stuffed animal.png'),
      title: 'I will get my stuffed animal',
      audio: 'appfiles/solutions/solution_animal.mp3',
      positive: true,
  };
  const solutionNervous = {
      img: generateImageUrl('images/Module14Images/practice/I will get nervous.png'),
      title: 'I will get nervous',
      audio: 'appfiles/solutions/solution_nervous.mp3',
      positive: false,
  };
  const solutionBest = {
      img: generateImageUrl('images/Module14Images/practice/I will do my best.png'),
      title: 'I will do my best',
      audio: 'appfiles/solutions/solution_best.mp3',
      positive: true,
  };
  const solutionNoNew = {
      img: generateImageUrl('images/Module14Images/practice/I will not try something new.png'),
      title: 'I will not try something new',
      audio: 'appfiles/solutions/solution_no_new.mp3',
      positive: false,
  };
  const solutionLightOn = {
      img: generateImageUrl('images/Module14Images/practice/I will turn on the light.png'),
      title: 'I will turn on the light',
      audio: 'appfiles/solutions/solution_light_on.mp3',
      positive: true,
  };
  const solutionDark = {
      img: generateImageUrl('images/Module14Images/practice/I will not turn on the light.png'),
      title: 'I will not turn on the light',
      audio: 'appfiles/solutions/solution_no_light.mp3',
      positive: false,
  };
  const solutionSorry = {
      img: generateImageUrl('images/Module14Images/practice/I will say sorry.png'),
      title: 'I will say sorry',
      audio: 'appfiles/solutions/solution_sorry.mp3',
      positive: true,
  };
  const solutionNap = {
      img: generateImageUrl('images/Module14Images/practice/I will take a nap.png'),
      title: 'I will take a nap',
      audio: 'appfiles/solutions/solution_nap.mp3',
      positive: true,
  };
  const solutionMusic = {
      img: generateImageUrl('images/Module14Images/practice/I will listen to music.png'),
      title: 'I will listen to music',
      audio: 'appfiles/solutions/solution_music.mp3',
      positive: true,
  };
  const solutionHello = {
      img: generateImageUrl('images/Module14Images/practice/I will say hello.png'),
      title: 'I will say hello',
      audio: 'appfiles/solutions/solution_hello.mp3',
      positive: true,
  };

  // Initializes question scenarios
  const madVideoGame = {
    prompt:
      'If you are mad because you did not finish your chores so you cannot play video games, what is a solution?',
    promptAudio: 'appfiles/solutions/scenario_mad_video_games.mp3',
    correctSolutions: [solutionDeepBreath, solutionCalm, solutionChores],
    incorrectSolutions: [
      solutionGetMad,
      solutionScream,
      solutionFrown,
      solutionBreakGame,
    ],
  };

  const madHungry = {
    prompt: 'If you are mad because you are hungry, what is a solution?',
    promptAudio: 'appfiles/solutions/scenario_mad_hungry.mp3',
    correctSolutions: [solutionEatFood, solutionSnack, solutionCalm],
    incorrectSolutions: [solutionGetMad, solutionScream, solutionFrown],
  };

  const sadKnee = {
    prompt:
      'If you are sad because you fell down and scraped your knee, what is a solution?',
    promptAudio: 'appfiles/solutions/scenario_sad_knee.mp3',
    correctSolutions: [
      solutionBandaid,
      solutionDeepBreath,
      solutionSmile,
      solutionTall,
    ],
    incorrectSolutions: [
      solutionFrown,
      solutionScream,
      solutionGetMad,
      solutionBreakGame,
    ],
  };

  const sadWant = {
    prompt:
      'If you are sad because you did not get what you wanted, what is a solution?',
    promptAudio: 'appfiles/solutions/scenario_sad_want.mp3',
    correctSolutions: [
      solutionSmile,
      solutionDeepBreath,
      solutionTall,
      solutionAnimal,
    ],
    incorrectSolutions: [solutionScream, solutionGetMad, solutionBreakGame],
  };

  const nervousNew = {
    prompt:
      'If you are nervous because you are trying something new, what is a solution?',
    promptAudio: 'appfiles/solutions/scenario_nervous_new.mp3',
    correctSolutions: [
      solutionBest,
      solutionTall,
      solutionDeepBreath,
      solutionSmile,
    ],
    incorrectSolutions: [
      solutionNervous,
      solutionNoNew,
      solutionFrown,
      solutionScream,
      solutionGetMad,
    ],
  };

  const nervousDark = {
    prompt: 'If you are nervous because it is dark, what is a solution?',
    promptAudio: 'appfiles/solutions/scenario_nervous_dark.mp3',
    correctSolutions: [
      solutionLightOn,
      solutionDeepBreath,
      solutionTall,
      solutionAnimal,
    ],
    incorrectSolutions: [
      solutionDark,
      solutionFrown,
      solutionNervous,
      solutionScream,
    ],
  };

  const madBrokeToy = {
    prompt: 'If you are mad because you broke your toy, what is a solution?',
    promptAudio: 'appfiles/solutions/scenario_mad_broke_toy.mp3',
    correctSolutions: [solutionDeepBreath, solutionSorry, solutionCalm],
    incorrectSolutions: [
      solutionScream,
      solutionFrown,
      solutionGetMad,
      solutionNervous,
    ],
  };

  const madTired = {
    prompt: 'If you are mad because you are tired, what is a solution?',
    promptAudio: 'appfiles/solutions/scenario_mad_tired.mp3',
    correctSolutions: [
      solutionNap,
      solutionSnack,
      solutionMusic,
      solutionBest,
      solutionSnack,
    ],
    incorrectSolutions: [
      solutionScream,
      solutionFrown,
      solutionGetMad,
      solutionBreakGame,
    ],
  };

  const sadNoOutside = {
    prompt:
      'If you are sad because you cannot play outside, what is a solution?',
    promptAudio: 'appfiles/solutions/scenario_sad_no_outside.mp3',
    correctSolutions: [
      solutionDeepBreath,
      solutionSmile,
      solutionMusic,
      solutionAnimal,
    ],
    incorrectSolutions: [
      solutionScream,
      solutionFrown,
      solutionGetMad,
      solutionBreakGame,
    ],
  };

  const sadMistake = {
    prompt: 'If you are sad because you made a mistake, what is a solution?',
    promptAudio: 'appfiles/solutions/scenario_sad_mistake.mp3',
    correctSolutions: [
      solutionDeepBreath,
      solutionSmile,
      solutionBest,
      solutionTall,
    ],
    incorrectSolutions: [
      solutionFrown,
      solutionGetMad,
      solutionScream,
      solutionNervous,
    ],
  };

  const nervousMeetNew = {
    prompt:
      'If you are nervous because you are meeting someone new, what is a solution?',
    promptAudio: 'appfiles/solutions/scenario_nervous_meet_new.mp3',
    correctSolutions: [
      solutionDeepBreath,
      solutionBest,
      solutionTall,
      solutionHello,
    ],
    incorrectSolutions: [
      solutionNervous,
      solutionFrown,
      solutionGetMad,
      solutionScream,
      solutionNoNew,
    ],
  };

  const nervousTest = {
    prompt:
      'If you are nervous because you are going to take a test, what is a solution?',
    promptAudio: 'appfiles/solutions/scenario_nervous_test.mp3',
    correctSolutions: [
      solutionDeepBreath,
      solutionBest,
      solutionTall,
      solutionSmile,
    ],
    incorrectSolutions: [solutionNervous, solutionFrown, solutionGetMad],
  };

  // Groups answers by their emotional category
  const madAnwsers = [madTired, madBrokeToy, madHungry, madVideoGame];
  const nervousAnwsers = [nervousNew, nervousDark, nervousMeetNew, nervousTest];
  const sadAnwsers = [sadKnee, sadWant, sadNoOutside, sadMistake];

  // Gets the gifs to allow the monkey to talk
  useEffect(() => {
    setIntroSound(getVideo('appfiles/understand_feelings/choose_feelings.mp3', login));
  }, []);

  // Decide what video to play based on what day we're on.
  useEffect(() => {
    if (props.unit4){
      setDisplayPracticeVideo(props.reviewVideo);
      setPracticeVideo(true);
    }
    else{
      switch (props.module.currentday) {
        case 1:
          setDisplayPracticeVideo(getVideo('appfiles/solutions/practice_day_1.mp4', login));
          setPracticeVideo(true);
          break;
        case 2:
          setDisplayPracticeVideo(getVideo('appfiles/solutions/practice_day_2.mp4', login));
          setPracticeVideo(true);
          break;
        case 3:
          setDisplayPracticeVideo(getVideo('appfiles/solutions/practice_day_3.mp4', login));
  
          setPracticeVideo(true);
          break;
        default:
          setPractice(true);
          setQuestion(true);
          break;
      }
    }

  }, []);

  // Set a timer for ms milliseconds
  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  useEffect(() => {
    if(practiceCount > 1) {
      updateScore();
      props.module.sectionCompleted = props.module.sectionCompleted + 1
      if (props.unit4){
        if (props.module.reviewIcon === false) {
          dispatch({ type: props.stepComplete, payload: 'practice' });
        }
        props.setDisplayPractice(false);
      }
      else{
        recording();
      }
    }
  }, [practiceCount]);

  const updateScore = async () => {
    try {
      await API.post('TIR', '/v3/student/result', {
        body: {
          student_id: login.studentid,
          metric: "practice_solutions",
          result: JSON.stringify({
            day: props.module.currentday,
            created: new Date().toISOString(),
            values: [{ value: score, target: 2 }],
          }),
        },
      });
    } catch (error) {
      console.log(error);
    }
  }; 

  // Sets up the game by selecting a question from the feelings category, then picking possible answers and setting them up
  async function setupGame(feeling) {
    for (let x = 0; x < document.getElementsByClassName("optionImage16").length; x++){
      document.getElementsByClassName("optionImage16")[x].style.borderColor  = 'black'
    }
    setFirstTime(true);
    setKeyword(feeling);
    setQuestion(false);
    setIntroSound('');
    setAnswerkey(null);
    setPractice(false);
    let number = 0;
    let numArray = [];
    switch (feeling) {
      case 'nervous':
        number = getRandomInt(nervousAnwsers.length);
        setChangeAnswer(nervousAnwsers[number].prompt);
        setIntroSound(getVideo(nervousAnwsers[number].promptAudio, login));
        numArray = [
          nervousAnwsers[number].correctSolutions[
            getRandomInt(nervousAnwsers[number].correctSolutions.length)
          ],
          nervousAnwsers[number].incorrectSolutions[
            getRandomInt(nervousAnwsers[number].incorrectSolutions.length)
          ],
        ];
        break;
      case 'sad':
        number = getRandomInt(sadAnwsers.length);
        setChangeAnswer(sadAnwsers[number].prompt);
        setIntroSound(getVideo(sadAnwsers[number].promptAudio, login));
        numArray = [
          sadAnwsers[number].correctSolutions[
            getRandomInt(sadAnwsers[number].correctSolutions.length)
          ],
          sadAnwsers[number].incorrectSolutions[
            getRandomInt(sadAnwsers[number].incorrectSolutions.length)
          ],
        ];
        break;
      case 'mad':
        number = getRandomInt(madAnwsers.length);
        setChangeAnswer(madAnwsers[number].prompt);
        setIntroSound(getVideo(madAnwsers[number].promptAudio, login));
        numArray = [
          madAnwsers[number].correctSolutions[
            getRandomInt(madAnwsers[number].correctSolutions.length)
          ],
          madAnwsers[number].incorrectSolutions[
            getRandomInt(madAnwsers[number].incorrectSolutions.length)
          ],
        ];
        break;
      default:
        break;
    }
    numArray = numArray
      .map((value) => ({ value, sort: Math.random() }))
      .sort((a, b) => a.sort - b.sort)
      .map(({ value }) => value);
    setOption1(numArray[0]);
    setOption2(numArray[1]);
    setMatchGame(true);
    sleep(100).then(() => {
      setQuestion(true);
    });
  }

  // Determines what the user selected as an answer and plays the respective voice line
  async function setAnswer(feeling, index) {
    for (let x = 0; x < document.getElementsByClassName("optionImage16").length; x++){
      document.getElementsByClassName("optionImage16")[x].style.borderColor  = 'black'
    }
    document.getElementsByClassName("optionImage16")[index].style.borderColor  = 'yellow'
    setAnswerkey(feeling);
    setAnimalVoice('');
    setAnimaTalk(false);
    setQuestion(false);
    setAnimalVoice(await getVideo(feeling.audio, login));
    setAnimaTalk(true);
  }

  const recording = async () => {
    if (props.module.currentday <= 3) {
      const text = [
        'Press record and say, "Cool!"',
        'Press record and say, "Awesome!"',
        'Press record and say, "Yummy!"',
      ];
      const introVideo = [
        'appfiles/solutions/practice_day_1_review.mp4',
        'appfiles/solutions/practice_day_2_review.mp4',
        'appfiles/solutions/practice_day_3_review.mp4',
      ];
      const influencers = [
        login.influencerid,
        login.influencerid1,
        login.influencerid2,
      ];
      let voice1 = getVideo( `appfiles/respond/respond_practice_record_${props.module.currentday + 4}.mp3`, login);
      let voice2 = getVideo( 'appfiles/respond/respond_practice_special_message.mp3', login);
      let voice3 = getVideo( 'appfiles/respond/respond_practice_watch_conversation.mp3', login);
      let voice4 = getVideo( 'appfiles/respond/respond_amazing_job.mp3', login);
      let response = getVideo( `appfiles/respond/respond_respond_${props.module.currentday + 4}.mp4`, login);
      let greeting = getVideo( `appfiles/respond/respond_greeting_${props.module.currentday + 4}.mp4`, login);
      let question7 = getVideo( `appfiles/respond/respond_question_${props.module.currentday + 4}.mp4`, login);
      let acknowledge7 = getVideo( `appfiles/respond/respond_acknowledge_${props.module.currentday + 4}.mp4`, login);
      let influencerVideo = await GetUserVideo( `influencers/${influencers[props.module.currentday - 1]}/respond_video_message.mp4`);
      let greetingResponse = await GetUserVideo( `userfiles/${props.module.StudentID}/feelings_practice_video_${props.module.currentday}.mp4`);
      let response7 = await GetUserVideo( `userfiles/${props.module.StudentID}/understand_feelings_practice_video_${props.module.currentday}.mp4`);
      let ask = await GetUserVideo( `userfiles/${props.module.StudentID}/change_feelings_practice_video_${props.module.currentday}.mp4`);
      setPracticeRrcording(
        <Day4Practice
          bigAnimal={true}
          module={props.module}
          celebrateVideo={
            getVideo(introVideo[
              props.module.currentday - 1
            ], login)
          }
          response7={response7}
          greetingResponse={greetingResponse}
          acknowledge7={acknowledge7}
          question7={question7}
          ask={ask}
          background={props.background}
          influencerVideo={influencerVideo}
          question={response}
          response={response}
          text={text[props.module.currentday - 1]}
          voice1={voice1}
          voice2={voice2}
          voice3={voice3}
          voice4={voice4}
          animate2={props.specialMessage}
          animate3={props.watchConversation}
          animate4={props.amazingJob}
          name={`solutions_practice_video_${props.module.currentday}.mp4`}
          greeting={greeting}
          closeVoice={voice4}
          animal={props.animal}
          setDisplayDay4Practice={
            props.setDisplayPractice
          }
          moduleNum={'MODULE14'}
        />
      );
      setMatchGame(false);
      setPracticeReview(true);
                                 
    } else {
      if (props.module.reviewIcon === false) {
        dispatch({ type: props.stepComplete, payload: 'practice' });
      }
      props.setDisplayPractice(false);
    }
  };

  // The HTML code for the practice module
  return (
    <>
      {practiceVideo && (
        <CloudfrontVideoFormat
          source={displayPracticeVideo}
          back='/solutions'
          background={props.background}
          close={props.setDisplayPractice}
          ended={() => {
            setPracticeVideo(false);
            switch (props.module.currentday) {
              case 1:
                setupGame('nervous')
                break;
              case 2:
                setupGame('sad')
                break;
              case 3:
                setupGame('mad')
                break;
              default:
                setPractice(true);
                setQuestion(true);
                break;
            }
          }}
        />
      )}
      {practice && (
        <div className='Module12Practice' style={{ backgroundImage: `url(${props.background})`}}>
          <img
            alt=''
            className='back-btn-ftb'
            src={Exit}
            onClick={() => {
              props.setDisplayPractice(false);
            }}
          ></img>
          <br />
          <h2 className='practiceHeader12'>
            Which feelings do you want to practice?
          </h2>

          <div className='grid'>
            <div className='grid-item' onClick={() => setupGame('nervous')}>
              <img
                alt=''
                className='crabExpression15'
                src={Nervous_Confident}
              />
              <h3 className='practiceText12'>Nervous & Confident</h3>
            </div>
            <div className='grid-item' onClick={() => setupGame('sad')}>
              <img alt='' className='crabExpression15' src={Sad_happy} />
              <h3 className='practiceText12'>Sad & Happy</h3>
            </div>
            <div className='grid-item' onClick={() => setupGame('mad')}>
              <img alt='' className='crabExpression15' src={Mad_Calm} />
              <h3 className='practiceText12'>Mad & Calm</h3>
            </div>
          </div>
        </div>
      )}

      {matchGame && (
        <div className='Module12MatchGame' style={{ backgroundImage: `url(${props.background})`}}>
          <img
            className='back-btn-ftb'
            alt=''
            src={Exit}
            onClick={() => {
              props.setDisplayPractice(false);
            }}
          ></img>
          <br />
          <h2 className='practiceHeader12'>What should you do?</h2>
          <h3 className='practiceQuestion12'>{changeAnswer}</h3>
          {(
            <img
              className='greenCheckPractice12'
              style={{opacity : answerkey ? 1 : 0, pointerEvents : answerkey ? "auto" : "none"}}
              src={greenCheck}
              alt=''
              onClick={() => {
                setAnimalVoice('');
                setAnimaTalk(false);
                if (answerkey.positive) {
                  if(firstTime) setScore(score+1); 
                  setPracticeCount(practiceCount+1);
                  const audio = new Audio(
                    generateImageUrl('media/Module1Videos/button_accept_item.mp3')
                  );
                  audio.play();
                  if (practiceCount < 1) {
                    setMatchGame(false);
                    setupGame(keyword);
                  }
                } else {
                  setFirstTime(false);
                  let sound = new Audio(getVideo('appfiles/eye_contact/andrea_try_again.mp3', login));
                  sound.play();
                  setAnswerkey(null);
                }
              }}
            />
          )}
          <br />
          <br />
          {answerkey ? (
            <div className='optionImage14'>
              <div className='set16'>
                <img alt='' className='crabExpression16' src={answerkey.img} />
                {/* <h4 className='practiceText12'>{answerkey.title}</h4> */}
              </div>
            </div>
          ) : (
            <img alt='' id='selectCrab14' src={selectImage} />
          )}
          <div className='gameGrid14'>
            <div className='optionImage16' onClick={() => setAnswer(option1, 0)}>
              <div className='set16'>
                <img alt='' className='crabExpression16' src={option1.img} />
                {/* <h4 className='practiceText12'>{option1.title}</h4> */}
              </div>
            </div>
            <div className='optionImage16' onClick={() => setAnswer(option2, 1)}>
              <div className='set16'>
                <img alt='' className='crabExpression16' src={option2.img} />
                {/* <h4 className='practiceText12'>{option2.title}</h4> */}
              </div>
            </div>
          </div>
        </div>
      )}

      {practiceReview && practiceRrcording}

      {!animalTalk && question && (
        <audio autoPlay onEnded={() => setQuestion(false)}>
          <source src={introSound}></source>
        </audio>
      )}
      {animalTalk && (
        <audio
          autoPlay
          onEnded={() => {
            setAnimaTalk(false);
          }}
        >
          <source src={animalVoice}></source>
        </audio>
      )}
    </>
  );
};
export default SolutionsPractice;
